import { render, staticRenderFns } from "./EditExchangeRate.vue?vue&type=template&id=3868095a&scoped=true"
import script from "./EditExchangeRate.vue?vue&type=script&lang=js"
export * from "./EditExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./EditExchangeRate.vue?vue&type=style&index=0&id=3868095a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868095a",
  null
  
)

export default component.exports